import { criterionKey } from '../../domain/scoring';
import { usePoints, useT } from '../../i18n';
import type { Task } from '../../domain/types';
import { selectAssessment, useAppStore } from '../../store/useAppStore';
import { Dialog, DialogFooterButton } from '../../ui/Dialog';
import { Icon } from '../../ui/Icon';
import styles from './Sheets.module.css';
import { HtmlText } from '../../ui/HtmlText';

/** Stufe eines bewerteten Kriteriums wählen. */
export function CriterionDialog({ task, index }: { task: Task; index: number }) {
  const t = useT();
  const points = usePoints();
  const assessment = useAppStore(selectAssessment);
  const choose = useAppStore((s) => s.chooseCriterion);
  const clear = useAppStore((s) => s.clearCriterion);
  const closeSheet = useAppStore((s) => s.closeSheet);

  if (task.scoring.kind !== 'criteria') return null;
  const criterion = task.scoring.criteria[index];
  const chosen = assessment.criteria[criterionKey(task.id, index)];

  return (
    <Dialog
      kicker={t.score.criterionOf(index + 1, task.scoring.criteria.length)}
      title={<HtmlText text={criterion.label} />}
      onClose={closeSheet}
    >
      <div className={`sc ${styles.optionList}`}>
        {criterion.options.map((option, i) => {
          const on = chosen === i;
          return (
            <button
              key={i}
              type="button"
              className={`tap ${styles.option}`}
              data-on={on}
              onClick={() => choose(task.id, index, i)}
            >
              <HtmlText className={styles.optionLabel} text={option.label} />
              <span className={styles.optionPoints}>{t.bogen.points(points(option.points))}</span>
              <span className={styles.optionMark}>
                {on && <Icon name="check" size={15} />}
              </span>
            </button>
          );
        })}
      </div>

      {chosen != null && (
        <DialogFooterButton onClick={() => clear(task.id, index)}>
          {t.score.clearChoice}
        </DialogFooterButton>
      )}
    </Dialog>
  );
}
